import React from 'react';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import { makeStyles } from '@material-ui/core/styles';
import TeamCard from './_team_card';
import { teamAmbassador } from './__data';


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(0),
  },
  paperTitle: {
    padding: theme.spacing(4),
    background: 'transparent',
    boxShadow: 'none'
  },
  section: {
    paddingTop: '5rem',
    paddingBottom: '8rem',
    backgroundColor: 'white'
  }
}));

const PartnerSection = () => {
  const classes = useStyles();

  return (
    <>
      <Grid
        alignItems="center"
        className={classes.section}
        component="article"
        container
        direction="column"
        justify="center"
        xs={12}
      >
        <Paper
          className={classes.paperTitle}
          component="header"
        >
          <Typography
            align="center"
            component="h2"
            variant="h1"
          >
            Notre Ambassadrice
          </Typography>
        </Paper>
        <Grid
          container
          justify="center"
          lg={8}
          md={10}
          sm={8}
          spacing={8}
          xl={6}
          xs={12}
        >
          {teamAmbassador.map((staff) => {
            return(
              <>
                <Grid
                  align="center"
                  item
                  md={3}
                  sm={6}
                  xs={8}
                >
                  <TeamCard staff={staff} />
                </Grid>
              </>
            )
          })}
        </Grid>
      </Grid>
    </>
  );
}

export default PartnerSection;
